export function formatDate (dateString) {
    if(dateString && dateString != ""){
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric', timeZone: 'UTC'}).format(date);
    } else {
        return 'None'
    }
}

export function formatDateMonthAndDay (dateString) {
    if(dateString && dateString != ""){
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', timeZone: 'UTC'}).format(date);
    } else {
        return 'None'
    }
}

export function formatDateMonthAndYear (dateString) {
    if(dateString && dateString != ""){
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US',{month:'2-digit',year:'2-digit', timeZone: 'UTC'}).format(date);
    } else {
        return 'None'
    }
}

export function formatDateTwoDigitYear (dateString) {
    if(dateString && dateString != ""){
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'2-digit', timeZone: 'UTC'}).format(date);
    } else {
        return 'None'
    }
}

export function formatDateWithWeekday (dateString) {
    if(dateString && dateString != ""){
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'2-digit', weekday:'short'}).format(date);
    } else {
        return 'None'
    }
}

export function formatDateWithMinutes (dateString) {
    if(dateString && dateString != ""){
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric', hour:'numeric', minute:'numeric'}).format(date);
    } else {
        return 'None'
    }
}

export function formatHTMLDate (dateString) {
    console.log('formatHTMLDate', dateString)
    if(dateString && dateString != ""){
        const date = new Date(dateString);
        return getDateAsString(date)
        // return date.toISOString().split('T')[0]
    } else {
        return 'None'
    }
}

export function formatDateYearMonthDay (dateString) {
    console.log('formatDateYearMonthDay', dateString)
    if(dateString && dateString != ""){
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US',{year:'numeric', month:'2-digit',day:'2-digit', timeZone: 'UTC'}).format(date);
    } else {
        return 'None'
    }
}

export function getTodaysDateAsString() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function getDateAsString(dateInstance) {
    console.log('getDateAsString', dateInstance)
    const year = dateInstance.getFullYear();
    const month = String(dateInstance.getMonth() + 1).padStart(2, '0');
    const day = String(dateInstance.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}